import request from '@/utils/request'
const apiPath = '/user'
import { downloadBlob } from '@/utils/download'
import qs from 'qs'
const userApi = {
  /**
   * 新增【我的线索】
   */
  create(data) {
    return request.post(`${apiPath}/myClue`, data)
  },
  /**
   * 修改【我的线索】
   */
  update(data) {
    return request.put(`${apiPath}/myClue`, data)
  },
  /**
   * 分页查询【我的线索】
   */
  fetchList(query) {
    return request.get(`${apiPath}/myClue`, { params: query })
  },
  /**
   * 查看【我的线索】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/myClue/${id}`)
  },
  // 转给他人
  transferTo(data) {
    return request.post(`${apiPath}/myClue/transferTo`, data)
  },
  // 添加标签
  customerTag(data) {
    return request.put(`${apiPath}/myClue/${data.id}/customerTag`, data.list)
  },
  // 移入公海
  takeHighSeas(data) {
    return request.post(`${apiPath}/myClue/takeHighSeas`, data)
  },
  // 升级身份
  identityUpgrade(data) {
    return request.post(`${apiPath}/myClue/identityUpgrade`, data)
  },
  /**
   * 删除单个【我的线索】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/myClue/${id}`)
  },
  /**
   * 批量删除【我的线索】
   */
  deleteBatch(ids) {
    return request.delete(`${apiPath}/myClue`, { data: ids })
  },
  // 线索跟进记录
  followUpRecord(query) {
    return request.get(`${apiPath}/followUpRecord`, { params: query })
  },
  // 用户浏览记录数量
  getAllCount(params) {
    const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.post(`${apiPath}/userBrowsingHistory/getAllCount`, data, {
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    })
  },
  // 浏览记录列表
  getBrowsingHistoryPageList(params) {
    const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.post(`${apiPath}/userBrowsingHistory/getBrowsingHistoryPageList`, data, {
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    })
  },
  // 分页查询【业务办理】
  getBusinessProcessing(query) {
    return request.get(`${apiPath}/businessProcessing`, { params: query })
  },
  // 公海线索导入
  clueImport(data) {
    return request.post(apiPath + '/myClue/clueImport', data)
  },
  // 我的线索导入
  myClueImport(data) {
    return request.post(apiPath + '/myClue/myClueImport', data)
  },
  // 导出
  exportExcels(query) {
    return request.get(apiPath + '/myClue/myClueExport', { params: query })
  },
  findAuditListByProcessingId(query) {
    return request.get(apiPath + '/businessAudit/findAuditListByProcessingId', { params: query })
  },
  template(query) {
    return request.get(`${apiPath}/myClue/template`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '下载模版.xlsx'))
  },
  template1(query) {
    return request.get(`${apiPath}/myClue/template1`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '下载模版.xlsx'))
  },
  // setIsEnableExpress(data) {
  //   return request.put(apiPath + '/tee/setIsEnable', data)
  // },
}
export default userApi
